import Svg, { Mask, Path } from '@rd-core-svg/svg'
import type { FlagsSvgProps } from '../svg.types'

export const GooglePayEnabledSmall = (props: FlagsSvgProps) => {
  return (
    <Svg width={42} height={24} viewBox="0 0 42 24" fill="none" {...props}>
      <Mask id="path-1-inside-1_22078_3762" fill="white">
        <Path d="M0 12C0 5.37258 5.37258 0 12 0H30C36.6274 0 42 5.37258 42 12C42 18.6274 36.6274 24 30 24H12C5.37258 24 0 18.6274 0 12Z" />
      </Mask>
      <Path
        d="M0 12C0 5.37258 5.37258 0 12 0H30C36.6274 0 42 5.37258 42 12C42 18.6274 36.6274 24 30 24H12C5.37258 24 0 18.6274 0 12Z"
        fill="white"
      />
      <Path
        d="M12 0V1H30V0V-1H12V0ZM30 24V23H12V24V25H30V24ZM12 24V23C5.92487 23 1 18.0751 1 12H0H-1C-1 19.1797 4.8203 25 12 25V24ZM42 12H41C41 18.0751 36.0751 23 30 23V24V25C37.1797 25 43 19.1797 43 12H42ZM30 0V1C36.0751 1 41 5.92487 41 12H42H43C43 4.8203 37.1797 -1 30 -1V0ZM12 0V-1C4.8203 -1 -1 4.8203 -1 12H0H1C1 5.92487 5.92487 1 12 1V0Z"
        fill="#303030"
        mask="url(#path-1-inside-1_22078_3762)"
      />
      <Path
        d="M20.205 12.71V15.735H19.245V8.26495H21.79C22.435 8.26495 22.985 8.47995 23.435 8.90995C23.895 9.33995 24.125 9.86495 24.125 10.485C24.125 11.12 23.895 11.645 23.435 12.07C22.99 12.495 22.44 12.705 21.79 12.705H20.205V12.71ZM20.205 9.18495V11.79H21.81C22.19 11.79 22.51 11.66 22.76 11.405C23.015 11.15 23.145 10.84 23.145 10.49C23.145 10.145 23.015 9.83995 22.76 9.58495C22.51 9.31995 22.195 9.18995 21.81 9.18995H20.205V9.18495Z"
        fill="#3C4043"
      />
      <Path
        d="M26.635 10.4551C27.345 10.4551 27.905 10.6451 28.315 11.0251C28.725 11.4051 28.93 11.9251 28.93 12.5851V15.7351H28.015V15.0251H27.975C27.58 15.6101 27.05 15.9001 26.39 15.9001C25.825 15.9001 25.355 15.7351 24.975 15.4001C24.595 15.0651 24.405 14.6501 24.405 14.1501C24.405 13.6201 24.605 13.2001 25.005 12.8901C25.405 12.5751 25.94 12.4201 26.605 12.4201C27.175 12.4201 27.645 12.5251 28.01 12.7351V12.5151C28.01 12.1801 27.88 11.9001 27.615 11.6651C27.35 11.4301 27.04 11.3151 26.685 11.3151C26.15 11.3151 25.725 11.5401 25.415 11.9951L24.57 11.4651C25.035 10.7901 25.725 10.4551 26.635 10.4551ZM25.395 14.1651C25.395 14.4151 25.5 14.6251 25.715 14.7901C25.925 14.9551 26.175 15.0401 26.46 15.0401C26.865 15.0401 27.225 14.8901 27.54 14.5901C27.855 14.2901 28.015 13.9401 28.015 13.5351C27.715 13.3001 27.3 13.1801 26.765 13.1801C26.375 13.1801 26.05 13.2751 25.79 13.4601C25.525 13.6551 25.395 13.8901 25.395 14.1651Z"
        fill="#3C4043"
      />
      <Path
        d="M34.15 10.6201L30.95 17.9801H29.96L31.15 15.4051L29.04 10.6201H30.085L31.605 14.2901H31.625L33.105 10.6201H34.15Z"
        fill="#3C4043"
      />
      <Path
        d="M16.3866 12.0999C16.3866 11.7869 16.3586 11.4874 16.3066 11.1994H12.2826V12.8494L14.6001 12.8499C14.5061 13.3989 14.2036 13.8669 13.7401 14.1789V15.2494H15.1196C15.9251 14.5039 16.3866 13.4019 16.3866 12.0999Z"
        fill="#4285F4"
      />
      <Path
        d="M13.7406 14.1789C13.3566 14.4379 12.8621 14.5894 12.2836 14.5894C11.1661 14.5894 10.2181 13.8364 9.87857 12.8214H8.45557V13.9254C9.16057 15.3244 10.6096 16.2844 12.2836 16.2844C13.4406 16.2844 14.4126 15.9039 15.1201 15.2489L13.7406 14.1789Z"
        fill="#34A853"
      />
      <Path
        d="M9.7445 12.0025C9.7445 11.7175 9.792 11.442 9.8785 11.183V10.079H8.4555C8.164 10.6575 8 11.3105 8 12.0025C8 12.6945 8.1645 13.3475 8.4555 13.926L9.8785 12.822C9.792 12.563 9.7445 12.2875 9.7445 12.0025Z"
        fill="#FABB05"
      />
      <Path
        d="M12.2836 9.41503C12.9151 9.41503 13.4806 9.63253 13.9271 10.0575L15.1496 8.83603C14.4071 8.14453 13.4391 7.72003 12.2836 7.72003C10.6101 7.72003 9.16057 8.68003 8.45557 10.079L9.87857 11.183C10.2181 10.168 11.1661 9.41503 12.2836 9.41503Z"
        fill="#E94235"
      />
    </Svg>
  )
}
